import { Controller } from "@hotwired/stimulus";

// Reloads the structured (v3) workflow form with a mapping picked from the
// library dropdown. The server (#edit) reads params[:library_mapping_uuid] and
// pre-fills the mapping. Mounted on the importer-mapping-container in
// _form_config.haml; the Reset button's data-action triggers reload().
export default class extends Controller {
  static targets = ['select']

  reload() {
    const uuid = this.selectTarget.value
    if (uuid === '') return
    window.location.href = `${window.location.pathname}?library_mapping_uuid=${uuid}`
  }
}
